const channelToHex = (value: number): string =>
  value.toString(16).padStart(2, "0");

/**
 * Resolves a computed CSS color string to #rrggbb (canvas-backed).
 */
export const resolveCssColorToHex = (cssColor: string): string | null => {
  if (!cssColor.trim()) {
    return null;
  }

  try {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    const context = canvas.getContext("2d");

    if (!context) {
      return null;
    }

    context.fillStyle = cssColor;
    context.fillRect(0, 0, 1, 1);
    const [red, green, blue, alpha] = context.getImageData(0, 0, 1, 1).data;

    if (alpha === 0) {
      return null;
    }

    return `#${channelToHex(red)}${channelToHex(green)}${channelToHex(blue)}`;
  } catch {
    return null;
  }
};

/**
 * Reads a :root custom property and resolves it to hex for meta theme-color.
 */
export const resolveCssVariableToHex = (variableName: string): string | null => {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();

  if (!raw) {
    return null;
  }

  return resolveCssColorToHex(raw);
};
